// Check-in / check-out dropdown helpers.
//
// Some databases contain every listing time twice (the seeder was run more than once).
// These helpers make the dropdowns show each time once and keep a listing that was saved
// with the duplicate id selected on the matching option.

// One option per distinct time (the first one wins).
export const dedupeTimings = (timings) => {
  if (!Array.isArray(timings)) return [];
  const seen = new Set();
  return timings.filter((item) => {
    const key = String(item?.time ?? '').trim().toLowerCase();
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
};

// Maps a stored timing id to the id of the option that is actually shown for that time.
export const canonicalTimingId = (timings, id) => {
  if (id === null || id === undefined || id === '') return '';
  if (!Array.isArray(timings)) return id;
  const stored = timings.find((item) => String(item?.id) === String(id));
  if (!stored) return id;
  const key = String(stored.time ?? '').trim().toLowerCase();
  const shown = timings.find((item) => String(item?.time ?? '').trim().toLowerCase() === key);
  return shown ? shown.id : id;
};
